// @ts-nocheck
import { BookOpen } from 'lucide-react';
import { ROUTES } from '@/utilities/constant';
import { c, Section, Field, useStudio, useNode, reqTag, useShown } from '../ui';
import { kbId, kbName, kbReady, kbFiles } from '../lookups';

export default function KnowledgeSection({ next, onNext, value, onChange }) {
  const { data, touch } = useStudio();
  const node = useNode('kb');
  const shown = useShown();
  const { items, loading } = data.kbs;
  const ready = items.filter(kbReady);
  const hidden = items.length - ready.length;
  const chosen = items.find((r) => String(kbId(r)) === String(value));

  const chosenHidden = !!chosen && !kbReady(chosen);
  const unknownValue = !!value && !loading && !chosen;
  const files = chosen ? kbFiles(chosen) : null;

  return (
    <Section
      id="kb"
      icon={BookOpen}
      title="Knowledge base"
      sub="The documents your agent reads to answer questions."
      tag={reqTag(node)}
      plainReq
      ok={node.ok}
      bad={node.bad}
      next={next('kb')}
      onNext={onNext}
    >
      <Field
        label="Knowledge base"
        required
        htmlFor="ags-kb"
        style={{ margin: 0 }}
        error={!value && shown('kb') && 'Choose a knowledge base so the agent has facts to answer from.'}
      >
        <select
          id="ags-kb"
          className={c('ctl', !value && shown('kb') && 'invalid', value && touchedGood())}
          value={value || ''}
          disabled={loading}
          onChange={(e) => {
            onChange(e.target.value);
            touch('kb');
          }}
          onBlur={() => touch('kb')}
        >
          <option value="">{loading ? 'Loading knowledge bases…' : 'Select a knowledge base'}</option>
          {ready.map((r) => (
            <option key={kbId(r)} value={kbId(r)}>
              {kbName(r)}
            </option>
          ))}
          {chosenHidden && (
            <option value={String(kbId(chosen))}>{kbName(chosen)} (still processing)</option>
          )}
          {unknownValue && <option value={String(value)}>Imported knowledge base ({String(value).slice(0, 8)}…) — not in your list</option>}
          {!chosen && !unknownValue && !!value && loading && <option value={String(value)}>Loading…</option>}
        </select>
        {unknownValue && (
          <p className={c('note')} style={{ marginTop: 10, color: 'var(--red)' }}>
            This knowledge base id came from the imported JSON and was not found in your account. Pick one of your own knowledge bases above.
          </p>
        )}

        {chosen && (
          <div className={c('item')} style={{ margin: '12px 0 0' }}>
            <span className={c('cb')}>
              <BookOpen className="ags-i" />
            </span>
            <div>
              <b>{kbName(chosen)}</b>
              <p>{files ? `${files} files` : 'Ready to use'}</p>
            </div>
            <div className={c('acts')}>
              <a className={c('btn small')} href={`/${ROUTES.AI_AGENT.KNOWLEDGE_BASE_LIST}`} target="_blank" rel="noreferrer">
                Manage files
              </a>
            </div>
          </div>
        )}
        {!loading && items.length === 0 && <p className={c('note')} style={{ marginTop: 10 }}>No knowledge bases created yet.</p>}
        {hidden > 0 && (
          <p className={c('note')} style={{ marginTop: 10 }}>
            {hidden} knowledge base{hidden > 1 ? 's are' : ' is'} still processing and hidden until ready.
          </p>
        )}
        <div className={c('note')} style={{ marginTop: 10 }}>
          Nothing here yet?{' '}
          <a className={c('btn ghost')} href={`/${ROUTES.AI_AGENT.KNOWLEDGE_BASE_CREATE}`} target="_blank" rel="noreferrer">
            Create a knowledge base
          </a>
        </div>
      </Field>
    </Section>
  );
}

const touchedGood = () => 'valid';
